var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/star"
  }, /*#__PURE__*/React.createElement("g", {
    id: "star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.6042 7.8125L32.2709 15.1458C32.7709 16.1667 34.1042 17.1458 35.2292 17.3333L41.8751 18.4375C46.1251 19.1458 47.1251 22.2292 44.0626 25.2708L38.8959 30.4375C38.0209 31.3125 37.5417 33 37.8126 34.2083L39.2917 40.6042C40.4584 45.6667 37.7709 47.625 33.2917 44.9792L27.0626 41.2917C25.9376 40.625 24.0834 40.625 22.9376 41.2917L16.7084 44.9792C12.2501 47.625 9.54172 45.6458 10.7084 40.6042L12.1876 34.2083C12.4584 33 11.9792 31.3125 11.1042 30.4375L5.93755 25.2708C2.89589 22.2292 3.87506 19.1458 8.12505 18.4375L14.7709 17.3333C15.8751 17.1458 17.2084 16.1667 17.7084 15.1458L21.3751 7.8125C23.3751 3.83333 26.6251 3.83333 28.6042 7.8125Z",
    stroke: "#8BC63E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.ee6ef184692b5450b7b8cc04b86df270.svg";
export { ForwardRef as ReactComponent };